<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-overlay :value="overlay" z-index="999">
                <div class="align-center justify-center text-center">
                    <v-progress-circular
                        indeterminate
                        :size="100"
                        :width="7"
                        color="#2DB9D1"
                    >
                        <v-img
                            src="/static/icon/favicon.ico"
                            :width="60"
                        ></v-img>
                    </v-progress-circular>
                    <p class="mt-5">{{fraseOverlay}}</p>
                </div>
            </v-overlay>
            <v-row class="pa-0 mt-0 mb-0">
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="pa-0 ">
                    <div style="display: flex; width:100%; height:100%; justify-content: flex-start;">
                        <hr class="vr"/>
                        <p class="tblName pb-2">Afiliación IDSE</p>
                    </div>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="pa-0 d-flex justify-end">
                    <v-btn
                        color="transparent"
                        @click="generarReporte('xlsx')"
                        rounded
                        class="btnReportes v-btn-excel elevation-0 pa-0"
                        style="min-width: 10px;"
                        :ripple="true"
                    >
                        <img src="/static/icon/xls.png" style="width:28px" />
                    </v-btn>
                    <v-btn
                        elevation="0"
                        class="btnNormalClaro ml-3"
                        @click="enviarIMSS()"
                    >
                        Enviar IMSS
                    </v-btn>
                    <BtnAcciones
                        :btnNombre="'Acciones'"
                        :btnColor="'color-58C5D8'"
                        class="ml-3"
                    >
                        <template v-slot:opciones>
                            <div
                                @click="selected_general.length === 0 ? null : exportar('txt')"
                                :style="selected_general.length === 0 ? 'cursor:not-allowed;' : 'cursor:pointer;'"
                                class="btnAccionesItem py-2"
                                :class="[selected_general.length === 0 ? 'deshabilitado':'']"
                            >
                                <span>Formato .txt para IDSE</span>
                            </div>
                            <!-- <div
                                @click="selected_general.length === 0 ? null : exportar('pdf')"
                                :style="selected_general.length === 0 ? 'cursor:not-allowed;' : 'cursor:pointer;'"
                                class="btnAccionesItem py-2"
                                :class="[selected_general.length === 0 ? 'deshabilitado':'']"
                            >
                                <span>Exportar PDF</span>
                            </div>
                            <div
                                @click="selected_general.length === 0 ? null : exportar('sua')"
                                :style="selected_general.length === 0 ? 'cursor:not-allowed;' : 'cursor:pointer;'"
                                class="btnAccionesItem py-2"
                                :class="[selected_general.length === 0 ? 'deshabilitado':'']"
                            >
                                <span>Exportar SUA</span>
                            </div> -->

                        </template>
                    </BtnAcciones>
                    <v-btn
                        height="40"
                        width="40"
                        fab
                        color="#FFFFFF"
                        class="elevation-0 mt-0 mr-3"
                        @click="refresh()"
                    >
                        <v-icon color="#96999A">refresh</v-icon>
                    </v-btn>
                    <!-- <v-btn
                        height="40"
                        width="40"
                        fab
                        color="#FFFFFF"
                        class="elevation-0 mt-0"
                        @click="abrirModalBuscar()"
                    >
                        <v-icon color="#96999A">mdi-magnify</v-icon>
                    </v-btn> -->
                </v-col>
            </v-row>
            <v-row class="mt-6">
                <v-col cols="12" xs="12" sm="12" md="12" class="div-card py-8">
                    <div>
                        <v-row v-if="rol == 'root'"  class="py-0 my-0 mx-2">
                            <v-col>
                                <v-autocomplete
                                    outlined
                                    :items="clientes"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Cliente"
                                    persistent-hint
                                    v-model="cliente_value"
                                    no-data-text="Datos no disponibles"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row class="py-0 my-0 mx-2">
                            <v-col cols="12" xs="12" sm="6" md="2" class="py-0">
                                <v-autocomplete
                                    outlined
                                    :items="itemsRegistrosPatronales"
                                    item-text="nombreClave"
                                    item-value="id"
                                    label="Registro patronal"
                                    persistent-hint
                                    v-model="registro_patronal_value"
                                    no-data-text="Datos no disponibles"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" xs="12" sm="6" md="2" class="py-0">
                                <VuetifyDatePicker
                                    outlined
                                    label="Fecha inicial"
                                    :valorDefecto="fecha_inicial"
                                    v-model="fecha_inicial"
                                    placeholder="dd/mm/aaaa"
                                    ref="FechaInicial"
                                />
                            </v-col>
                            <v-col cols="12" xs="12" sm="6" md="2" class="py-0">
                                <VuetifyDatePicker
                                    outlined
                                    label="Fecha final"
                                    :valorDefecto="fecha_final"
                                    v-model="fecha_final"
                                    placeholder="dd/mm/aaaa"
                                    ref="FechaFinal"
                                />
                            </v-col>
                            <v-col cols="12" xs="12" sm="6" md="3" class="py-0">
                                <v-autocomplete
                                    outlined
                                    :items="itemsEmpleados"
                                    item-text="nombre_completo"
                                    item-value="id"
                                    label="Empleado"
                                    persistent-hint
                                    v-model="empleado_value"
                                    clearable
                                    no-data-text="Datos no disponibles"
                                    :disabled="registro_patronal_value == null"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" xs="12" sm="6" md="3" class="py-0">
                                <div class="d-flex align-center">
                                    <v-autocomplete
                                        outlined
                                        :items="itemsEstatus"
                                        item-text="nombre"
                                        item-value="valor"
                                        label="Estatus de aviso"
                                        persistent-hint
                                        v-model="estatus"
                                        clearable
                                        no-data-text="Datos no disponibles"
                                        class="flex-grow-1"
                                    ></v-autocomplete>
                                    <v-checkbox
                                        v-model="mostrarBusquedaAvanzadaEstatus"
                                        class="ml-2 mt-0 pt-0 mb-3"
                                        color="#2DB9D1"
                                        label="Búsqueda avanzada"
                                    ></v-checkbox>
                                </div>
                            </v-col>
                        </v-row>
                        <v-expand-transition>
                            <div v-show="mostrarBusquedaAvanzadaEstatus">
                                <v-row class="py-0 my-0 mx-2 mt-1">
                                    <v-col cols="12" xs="12" sm="6" md="3" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="NSS"
                                            v-model="nss"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="6" md="3" class="py-0">
                                        <v-autocomplete
                                            outlined
                                            :items="itemsTiposTrabajadores"
                                            item-text="descripcion"
                                            item-value="id"
                                            label="Tipo trabajador"
                                            persistent-hint
                                            v-model="tipo_trabajador_id"
                                            clearable
                                            no-data-text="Datos no disponibles"
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="6" md="3" class="py-0">
                                        <v-autocomplete
                                            outlined
                                            :items="itemsTiposSalarios"
                                            item-text="descripcion"
                                            item-value="id"
                                            label="Tipo salario"
                                            persistent-hint
                                            v-model="tipo_salario_id"
                                            clearable
                                            no-data-text="Datos no disponibles"
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="6" md="3" class="py-0">
                                        <v-text-field
                                            outlined
                                            label="Número de lote"
                                            v-model="lote"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-expand-transition>
                        <v-row class="d-flex justify-end ma-0 pa-0 mb-3 mr-5">
                            <v-btn
                                elevation="0"
                                class="btnNormalClaro ml-3"
                                v-if="rol == 'root'"
                                @click="sincronizarEmpleados()"
                                :disabled="showTabla == false"
                            >
                                Sincronizar <!-- Sincronizar empleados lotes -->
                            </v-btn>
                            <v-btn
                                elevation="0"
                                class="btnNormalClaro ml-3"
                                @click="filtarMovimientos()"
                            >
                                Filtrar <!-- obtener movimientos -->
                            </v-btn>
                        </v-row>
                        <v-divider class="mx-6"></v-divider>


                        <div v-if="showTabla == false" class="d-flex justify-center align-center text-center text-no-elementos my-10">
                            No hay elementos para mostrar
                        </div>

                        <template v-else>
                            <v-row class="py-0 my-0 mt-5 mx-6">
                                <div
                                    class="btn-afiliacion mr-2 d-flex justify-center align-center"
                                    :class="btnAfiliacion == 'btn1' ? 'btn-activo':'btn-inactivo'"
                                    @click="filtroAfiliacion('btn1')"
                                >
                                    <span class="ma-3">Reingresos</span>
                                </div>
                                <div
                                    class="btn-afiliacion mr-2 d-flex justify-center align-center"
                                    :class="btnAfiliacion == 'btn2' ? 'btn-activo':'btn-inactivo'"
                                    @click="filtroAfiliacion('btn2')"
                                >
                                    <span class="ma-3">Modificación salarios</span>
                                </div>
                                <div
                                    class="btn-afiliacion mr-2 d-flex justify-center align-center"
                                    :class="btnAfiliacion == 'btn3' ? 'btn-activo':'btn-inactivo'"
                                    @click="filtroAfiliacion('btn3')"
                                >
                                    <span class="ma-3">Bajas</span>
                                </div>
                                <div
                                    class="btn-afiliacion mr-2 d-flex justify-center align-center"
                                    :class="btnAfiliacion == 'btn4' ? 'btn-activo':'btn-inactivo'"
                                    @click="filtroAfiliacion('btn4')"
                                >
                                    <span class="ma-3">Todos</span>
                                </div>
                            </v-row>

                            <data-table
                                class="mt-0 mx-5"
                                ref="tablaAfiliacion"
                                :url="url"
                                :columns="columns"
                                :filters="filters"
                                :showAdvancedFilters="false"
                                :perPage="[10,25,50,100]"
                                :idTabla="'tablaAfiliacion'"
                                :classPagination="'box-shadow-none'"
                                :isSelectable="true"
                                :unselected="unselected_general"
                                @selectAllEvent="selectAll"
                                :valCheck="'id'"
                                cellPadding="5px 5px"
                                headerPadding="5px 5px"
                            >
                                <tbody slot="body" slot-scope="{ data }" class="tablaBody">
                                    <tr :key="item.id" v-for="item in data">
                                        <td style="width:115px !important; ">
                                            <div class="d-flex justify-center align-center text-center">
                                                <v-checkbox class="my-0" primary hide-details :value="item.id" v-model="selected_general" ></v-checkbox>
                                            </div>
                                        </td>
                                        <td style="padding: 5px;"><div>{{item.registro_patronal}}</div></td>
                                        <td style="padding: 5px;"><div>{{item.clave_empleado}}</div></td>
                                        <td style="padding: 5px;"><div>{{item.nombre}}</div></td>
                                        <td style="padding: 5px;"><div>{{item.apellido_paterno}}</div></td>
                                        <td style="padding: 5px;"><div>{{item.apellido_materno}}</div></td>
                                        <td style="padding: 5px;"><div style="white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">{{item.nss}}</div></td>
                                        <td style="padding: 5px;"><div>{{item.sbc}}</div></td>
                                        <td v-if="btnAfiliacion === 'btn4' && item.tipo_movimiento_clave == '08'" style="padding: 5px;"><div>Reingresos</div></td>
                                        <td v-if="btnAfiliacion === 'btn4' && item.tipo_movimiento_clave == '07'" style="padding: 5px;"><div>Modificación salarios</div></td>
                                        <td v-if="btnAfiliacion === 'btn4' && item.tipo_movimiento_clave == '02'" style="padding: 5px;"><div>Bajas</div></td>
                                        <td style="padding: 5px;"><div>{{dateFormat(item.fecha_movimiento, 'tabla')}}</div></td>
                                        <td style="padding: 5px;"><div style="white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">{{item.curp}}</div></td>
                                        <td style="padding: 5px;"><div>{{item.umf}}</div></td>
                                        <td style="padding: 5px;"><div>{{item.tipo_trabajador}}</div></td>
                                        <td style="padding: 5px;"><div>{{item.tipo_salario}}</div></td>
                                        <td style="padding: 5px;"><div>{{item.jornada_reducida}}</div></td>
                                        <td style="padding: 5px;"><div>{{item.estado}}</div></td>
                                        <td style="padding: 5px;"><div>{{ item.fecha_envio == "" ? "NA" : dateFormat(item.fecha_envio, 'tabla')}}</div></td>
                                        <td style="padding: 5px;"><div>{{item.numero_lote}}</div></td>
                                        <td style="padding: 5px;">
                                            <div v-if="item.acuse_recibido === null || item.acuse_recibido === ''"></div>
                                            <div v-else>
                                                <v-btn
                                                    icon
                                                    size="small"
                                                    variant="text"
                                                    @click="descarga(item, 'acuse')"
                                                >
                                                    <v-img
                                                        src="/static/svg/pdf.svg"
                                                        width="20"
                                                        height="20"
                                                        class="mx-2 pdf-icon"
                                                    />
                                                </v-btn>
                                            </div>
                                        </td>
                                        <td style="padding: 5px;">
                                            <div v-if="item.acuse_operado === null || item.acuse_operado === ''"></div>
                                            <div v-else>
                                                <v-btn
                                                    icon
                                                    size="small"
                                                    variant="text"
                                                    @click="descarga(item, 'respuesta')"
                                                >
                                                    <v-img
                                                        src="/static/svg/pdf.svg"
                                                        width="20"
                                                        height="20"
                                                        class="mx-2 pdf-icon"
                                                    />
                                                </v-btn>
                                            </div>
                                        </td>
                                        <td style="padding: 5px;">
                                            <div v-if="item.acuse_rechazo === null || item.acuse_rechazo === ''"></div>
                                            <div v-else>
                                                <v-btn
                                                    icon
                                                    size="small"
                                                    variant="text"
                                                    @click="descarga(item, 'rechazo')"
                                                >
                                                    <v-img
                                                        src="/static/svg/pdf.svg"
                                                        width="20"
                                                        height="20"
                                                        class="mx-2 pdf-icon"
                                                    />
                                                </v-btn>
                                            </div>
                                        </td>
                                        <td style="padding: 5px;"><div>{{item.causa_rechazo}}</div></td>
                                    </tr>
                                </tbody>
                            </data-table>
                        </template>
                    </div>
                </v-col>
            </v-row>
        </v-container>

        <!-- Modal de errores -->
        <v-dialog v-model="dialogErrores" max-width="800px" persistent>
            <v-card>
                <v-card-title class="d-flex justify-space-between align-center">
                    <span class="text-h6">{{ tituloError01 }}</span>
                    <v-btn icon @click="dialogErrores = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                    <p class="mb-4" style="color: #F57C00;">
                        <v-icon color="#F57C00" class="mr-2">mdi-alert</v-icon>
                        {{ tituloError02 }}
                    </p>
                    <v-list dense class="error-list">
                        <v-list-item
                            v-for="(error, index) in erroresExportacion"
                            :key="index"
                            class="error-item mb-2"
                        >
                            <v-list-item-content>
                                <v-list-item-title class="error-title">
                                    <v-icon small color="error" class="mr-2">mdi-alert-circle</v-icon>
                                    {{ error }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="btnNormalClaro"
                        @click="dialogErrores = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import Datatable from '@/components/datatable/Datatable.vue';
import BtnAcciones from '@/components/BtnAcciones.vue';
import VuetifyDatePicker from '@/components/VuetifyDatePicker.vue';
import Notify from '@/plugins/notify';
import clienteApi from '@/api/clientes';
import apiRegistroPatronal from "@/api/nominas/registroPatronal";
import apiSeguridadSocial from "@/api/nominas/seguridadSocial";
import apiEmpleados from "@/api/empleados";
import datos from '../../js/datos.js'
import { param } from 'jquery';

export default {
    components: {
        'data-table': Datatable,
        BtnAcciones,
        VuetifyDatePicker,
    },
    computed: {
        columns() {
            const baseColumns = [
                {
                    label: 'Registro Patronal',
                    name: 'registro_patronal',
                    filterable: false
                },
                {
                    label: 'Clave empleado',
                    name: 'clave_empleado',
                    filterable: false
                },
                {
                    label: 'Nombre',
                    name: 'nombre',
                    filterable: false
                },
                {
                    label: 'Apellido paterno',
                    name: 'apellido_paterno',
                    filterable: false
                },
                {
                    label: 'Apellido materno',
                    name: 'apellido_materno',
                    filterable: false
                },
                {
                    label: 'NSS',
                    name: 'nss',
                    filterable: false
                },
                {
                    label: 'SBC',
                    name: 'sbc',
                    filterable: false
                },
            ];

            // Agregar columna "Tipo de movimiento" solo cuando btnAfiliacion es 'btn4'
            if (this.btnAfiliacion === 'btn4') {
                baseColumns.push({
                    label: 'Tipo de movimiento',
                    name: 'tipo_movimiento',
                    filterable: false
                });
            }

            // Agregar el resto de columnas
            baseColumns.push(
                {
                    label: 'Fecha de movimiento',
                    name: 'fecha_movimiento',
                    filterable: false
                },
                {
                    label: 'CURP',
                    name: 'curp',
                    filterable: false
                },
                {
                    label: 'UMF',
                    name: 'umf',
                    filterable: false
                },
                {
                    label: 'Tipo trabajador',
                    name: 'tipo_trabajador',
                    filterable: false
                },
                {
                    label: 'Tipo salario',
                    name: 'tipo_salario',
                    filterable: false
                },
                {
                    label: 'Jornada reducida',
                    name: 'jornada_reducida',
                    filterable: false
                },
                {
                    label: 'Estado',
                    name: 'estado',
                    filterable: false
                },
                {
                    label: 'Fecha de envío',
                    name: 'fecha_envio',
                    filterable: false
                },
                {
                    label: 'Número de lote',
                    name: 'numero_lote',
                    filterable: false
                },
                {
                    label: 'Acuse recibido',
                    name: 'acuse_recibido',
                    filterable: false
                },
                {
                    label: 'Acuse operado',
                    name: 'acuse_operado',
                    filterable: false
                },
                {
                    label: 'Acuse de rechazo',
                    name: 'acuse_rechazo',
                    filterable: false
                },
                {
                    label: 'Causa de rechazo',
                    name: 'causa_rechazo',
                    filterable: false
                }
            );

            return baseColumns;
        },
    },
    data() {
        const hoy = new Date();
        const anio = hoy.getFullYear();
        const mes = hoy.getMonth();
        const pad = (n) => String(n).padStart(2, '0');
        const primerDia = `${anio}-${pad(mes + 1)}-01`;
        const ultimoDia = `${anio}-${pad(mes + 1)}-${pad(new Date(anio, mes + 1, 0).getDate())}`;

        return {
            url         : "seguridad-social/lotes/find-movimientos",
            filters     : {
                activo    :true,
                paginate  :true,
                order     :"asc",
                registro_patronal_id: null,
                tipo_movimiento_clave: '08',
                estatus_movimiento: null,
                fecha_movimiento_min: null,
                fecha_movimiento_max: null,
                tipo_trabajador_id: null,
                tipo_salario_id: null,
                lote: null,
                nss: null,
                empleado_id: null,
                tipo: 'json'
            },
            datosLogin      : null,
            rol             : null,
            userData        : this.$session.get('usuario'),
            accion          : null,
            tituloModal     : null,
            imagen          : "",
            dialog          : false,
            isLoading       : false,
            isSaving        : false,
            dataFake        : [],
            btnAfiliacion   : 'btn1',

            cliente_value   : null,
            clientes        : [],

            itemsRegistrosPatronales: [],
            registro_patronal_value : null,
            itemsEmpleados          : [],
            empleado_value          : null,
            fecha_inicial           : primerDia,
            fecha_final             : ultimoDia,
            itemsEstatus            : [
                { valor: 'PENDIENTE', nombre: 'PENDIENTE' },
                { valor: 'ENVIADO', nombre: 'ENVIADO' },
                { valor: 'RECHAZADO', nombre: 'RECHAZADO' },
                { valor: 'PROCESADO', nombre: 'PROCESADO' },
            ],
            estatus                 : null,
            showTabla               : false,
            checkAll                : false,
            selected_general        : [],
            unselected_general      : [],
            dialogErrores           : false,
            erroresExportacion      : [],
            tituloError01           : '',
            tituloError02           : '',
            fraseOverlay            : 'Descargando...',
            overlay                 : false,
            itemsTiposTrabajadores  : [],
            itemsTiposSalarios      : [],
            mostrarBusquedaAvanzadaEstatus: false,
            tipo_trabajador_id      : null,
            tipo_salario_id         : null,
            lote                    : null,
            nss                     : null,
        }
    },
    watch: {
        cliente_value: function(val) {
            this.registro_patronal_value = null
            if(val != null) {
                this.getRegistrosPatronales(val);
            }
        },
        registro_patronal_value: function(val) {
            if(val != null){
                this.filters.registro_patronal_id = val
                this.obtenerEmpleadosConFiltros()
            }
            else {
                this.empleado_value = null
                this.itemsEmpleados = []
                this.filters.empleado_id = null
            }
            this.showTabla = false;
        },
        fecha_inicial: function() {
            this.obtenerEmpleadosConFiltros();
        },
        fecha_final: function() {
            this.obtenerEmpleadosConFiltros();
        },
        mostrarBusquedaAvanzadaEstatus: function(val) {
            if(!val) {
                this.tipo_trabajador_id = null;
                this.tipo_salario_id = null;
                this.lote = null;
                this.nss = null;
            }
        }
    },
    methods: {
        descarga(item, tipoAcuse ){
            const FileDownload = require("js-file-download");
            const axios = require("axios");

            let url = "seguridad-social/lotes/reporte";
            let nombre = ``;
            let tipoArchivo = '';
            if(tipoAcuse == 'acuse'){
                nombre = `ACUSE_RECIBIDO_${item.nombre}.pdf`;
                tipoArchivo = 'acuse';
                switch (item.tipo_movimiento_clave) {
                    case '08'://reingreso
                        nombre = `REINGRESO_${item.nombre}_${item.numero_lote ? item.numero_lote : 'na'  }_RECIBIDO.pdf`;
                        break;
                    case '07'://modificacion de salario
                        nombre = `MODIFICACION DE SALARIO_${item.nombre}_${item.numero_lote ? item.numero_lote : 'na'  }_RECIBIDO.pdf`;
                        break;
                    case '02'://baja
                        nombre = `BAJA_${item.nombre}_${item.numero_lote ? item.numero_lote : 'na'  }_RECIBIDO.pdf`;
                        break;
                    default:
                        nombre = `ACUSE_RECIBIDO_${item.nombre}_${item.numero_lote ? item.numero_lote : 'na'  }_RECIBIDO.pdf`;
                        break;
                }
            }
            else if(tipoAcuse == 'respuesta'){
                nombre = `ACUSE_OPERADO_${item.nombre}.pdf`;
                tipoArchivo = 'respuesta';
                switch (item.tipo_movimiento_clave) {
                    case '08'://reingreso
                        nombre = `REINGRESO_${item.nombre}_${item.numero_lote ? item.numero_lote : 'na'  }_OPERADO.pdf`;
                        break;
                    case '07'://modificacion de salario
                        nombre = `MODIFICACION DE SALARIO_${item.nombre}_${item.numero_lote ? item.numero_lote : 'na'  }_OPERADO.pdf`;
                        break;
                    case '02'://baja
                        nombre = `BAJA_${item.nombre}_${item.numero_lote ? item.numero_lote : 'na'  }_OPERADO.pdf`;
                        break;
                    default:
                        nombre = `ACUSE_OPERADO_${item.nombre}_${item.numero_lote ? item.numero_lote : 'na'  }_OPERADO.pdf`;
                        break;
                }
            }
            else if(tipoAcuse == 'rechazo'){
                nombre = `ACUSE_RECHAZO_${item.nombre}.pdf`;
                tipoArchivo = 'rechazo';
            }


            this.frase = "Descargando archivo";
            this.overlayDesgarga = true;

            let parametros = {
                registro_id: item.id,
                archivo: tipoArchivo,
                tipo: 'movimiento'
            }


            try {
                axios({
                    method: "post",
                    url: url,
                    responseType: "blob",
                    data: parametros
                }).then(function(response) {
                    FileDownload(response.data, nombre);
                });
            } catch (error) {
                console.log(error);
            }finally {
                this.overlayDesgarga = false;
            }
        },
        async exportar(tipo = 'txt'){
            if(this.selected_general.length === 0) {
                Notify.ErrorToast("Debe seleccionar al menos un movimiento para exportar.");
                return;
            }

            if(this.registro_patronal_value == null) {
                Notify.ErrorToast("Debe seleccionar un registro patronal.");
                return;
            }

            let parametros = {
                registro_patronal_id: this.registro_patronal_value,
                movimientos: this.selected_general
            };

            this.tituloError01 = 'Errores en la exportación ';
            this.tituloError02 = 'El archivo se exportó pero se encontraron los siguientes errores:';

            try {
                const response = await apiSeguridadSocial.exportSeguridadSocial(parametros);

                // Obtener Content-Type que contiene el JSON con Filename y Dispmag (errores)
                const contentType = response.headers['content-type'] || response.headers['Content-Type'];

                let nombreArchivo = 'archivo_exportado.txt'; // Nombre por defecto
                let errores = [];

                // Parsear el Content-Type como JSON para obtener Filename y Dispmag
                if (contentType) {
                    try {
                        const contentData = JSON.parse(contentType);

                        // Obtener el nombre del archivo
                        if (contentData.Filename) {
                            nombreArchivo = contentData.Filename;
                        }

                        // Obtener los errores (si existen)
                        if (contentData.Dispmag && Array.isArray(contentData.Dispmag) && contentData.Dispmag.length > 0) {
                            errores = contentData.Dispmag;
                        }
                    } catch (parseError) {
                        console.error('Error al parsear Content-Type:', parseError);
                    }
                }

                // Determinar el tipo MIME según la extensión
                const esZip = nombreArchivo.toLowerCase().endsWith('.zip');
                const tipoMime = esZip ? 'application/zip' : 'text/plain';

                // Crear blob y descargar archivo
                const blob = new Blob([response.data], { type: tipoMime });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = nombreArchivo;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                // Verificar el status de la respuesta y mostrar errores si existen
                if (response.status === 200 || response.status === 202) {
                    if (errores.length > 0) {
                        // Hay errores, mostrar el modal
                        this.erroresExportacion = errores;
                        this.dialogErrores = true;
                    } else {
                        Notify.SuccessToast("Archivo exportado correctamente.");
                    }
                }
            } catch(error) {
                console.error(error);
                if(error.response && error.response.data) {
                    Notify.ErrorToast("Error al exportar el archivo: " + (error.response.data.error || error.response.data.message));
                } else {
                    Notify.ErrorToast("Error al exportar el archivo.");
                }
            }
        },
        async enviarIMSS(){
            if(this.selected_general.length === 0) {
                Notify.ErrorToast("Debe seleccionar al menos un movimiento para enviar.");
                return;
            }

            if(this.registro_patronal_value == null) {
                Notify.ErrorToast("Debe seleccionar un registro patronal.");
                return;
            }

            let parametros = {
                registro_patronal_id: this.registro_patronal_value,
                movimientos: this.selected_general
            };

            this.tituloError01 = 'Errores al enviar al IMSS ';
            this.tituloError02 = 'Los datos se enviaron pero se encontraron los siguientes errores:';

            Notify.Alert(
                "ADVERTENCIA",
                "Se enviarán los movimientos hacia el IMSS de los registros seleccionados. Esta acción no es reversible. ¿Desea continuar?",
                "Enviar",
                async () => {
                    try {
                        const response = await apiSeguridadSocial.enviarIMSS(parametros);


                        // Verificar el status de la respuesta y mostrar errores si existen
                        if (response.status === 200) {
                            Notify.Success("Operación exitosa", "El envío de movimientos afiliatorios se ha realizado correctamente.");
                            this.$refs.tablaAfiliacion.getData();
                        }
                        else if (response.status === 202) {
                            // abrir modal de errores
                            this.erroresExportacion = response.observaciones || [];
                            this.dialogErrores = true;
                            this.$refs.tablaAfiliacion.getData();
                        }
                    } catch(error) {
                        console.error(error.response.data);
                        if(error.response && error.response.data) {
                            Notify.ErrorToast("Error al enviar los datos: " + (error.response.data.error || error.response.data.message));
                            if(error.response.data.observaciones){
                                this.erroresExportacion = error.response.data.observaciones;
                                this.dialogErrores = true;
                            }
                        } else {
                            Notify.ErrorToast("Error al enviar los datos.");
                        }
                    }
                }
            )

        },
        obtenerFechaDescarga() {
            const fecha = new Date();
            const dia = String(fecha.getDate()).padStart(2, '0');
            const mes = String(fecha.getMonth() + 1).padStart(2, '0');
            const anio = fecha.getFullYear();
            return `${dia}-${mes}-${anio}`;
        },
        generarNumeroAleatorio() {
            return Math.floor(Math.random() * 1000000);
        },
        generarReporte(tipo = 'xlsx'){
            if(this.registro_patronal_value == null) {
                Notify.ErrorToast("Debe seleccionar un registro patronal.");
                return;
            }
            if(this.fecha_inicial == null || this.fecha_final == null) {
                Notify.ErrorToast("Debe seleccionar un rango de fechas.");
                return;
            }

            this.overlay = true
            this.filters.fecha_movimiento_min = this.fecha_inicial
            this.filters.fecha_movimiento_max = this.fecha_final
            this.filters.estatus_movimiento = this.estatus
            this.filters.tipo_trabajador_id = this.mostrarBusquedaAvanzadaEstatus ? this.tipo_trabajador_id : null
            this.filters.tipo_salario_id = this.mostrarBusquedaAvanzadaEstatus ? this.tipo_salario_id : null
            this.filters.lote = this.mostrarBusquedaAvanzadaEstatus ? this.lote : null
            this.filters.nss = this.mostrarBusquedaAvanzadaEstatus ? this.nss : null
            this.filters.tipo = tipo

            // Generar nombre del archivo
            const fechaDescarga = this.obtenerFechaDescarga();
            const numeroAleatorio = this.generarNumeroAleatorio();
            let nombreBase = '';

            switch (this.filters.tipo_movimiento_clave) {
                case '08':
                    nombreBase = 'Avisos de reingresos';
                    break;
                case '07':
                    nombreBase = 'Avisos de modificaciones de salarios';
                    break;
                case '02':
                    nombreBase = 'Avisos de bajas';
                    break;
                default:
                    nombreBase = 'Avisos de movimientos afiliatorios';
                    break;
            }

            const nombre = `${nombreBase}_${fechaDescarga}_${numeroAleatorio}.${tipo}`;

            const FileDownload = require("js-file-download");
            const axios = require("axios");
            let url = "seguridad-social/lotes/find-movimientos";
            let parametros = this.filters;
            let self = this;
            try {
                axios({
                    method: "get",
                    url: url,
                    responseType: "blob",
                    params: parametros,
                }).then(function(response) {
                    FileDownload(response.data, nombre);
                    self.filters.tipo = 'json'
                    self.overlay = false
                });
            } catch (error) {
                console.log(error);
            }
        },
        abrirModalBuscar(){

        },
        filtroAfiliacion(btn = 'btn1'){
            this.btnAfiliacion = btn;

            if(btn == 'btn1'){
                this.filters.tipo_movimiento_clave = '08'
                this.$refs.tablaAfiliacion.getData();
            }
            else if(btn == 'btn2'){
                this.filters.tipo_movimiento_clave = '07'
                this.$refs.tablaAfiliacion.getData();
            }
            else if(btn == 'btn3') {
                this.filters.tipo_movimiento_clave = '02'
                this.$refs.tablaAfiliacion.getData();
            }
            else if(btn == 'btn4') {
                this.filters.tipo_movimiento_clave = null
                this.$refs.tablaAfiliacion.getData();
            }


        },
        getClientes(cliente = null) {
            let param = { activo: true, paginate: false }
            clienteApi.getClientes(param).then((response) => {
                this.clientes = response.data;
            })
            .catch(error => {
                this.resetValue();
                Notify.ErrorToast(error.response.data.error);
            });
        },

        obtenerEmpleadosConFiltros() {
            if (this.registro_patronal_value == null) {
                return;
            }

            if (!this.esFechaValida(this.fecha_inicial) || !this.esFechaValida(this.fecha_final)) {
                return;
            }

            this.getEmpleados(this.registro_patronal_value, this.fecha_inicial, this.fecha_final);
        },

        esFechaValida(fecha) {
            if (!fecha || typeof fecha !== 'string') {
                return false;
            }

            const formatoISO = fecha.match(/^(\d{4})-(\d{2})-(\d{2})$/);
            const formatoLatam = fecha.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);

            let year;
            let month;
            let day;

            if (formatoISO) {
                year = Number(formatoISO[1]);
                month = Number(formatoISO[2]);
                day = Number(formatoISO[3]);
            } else if (formatoLatam) {
                day = Number(formatoLatam[1]);
                month = Number(formatoLatam[2]);
                year = Number(formatoLatam[3]);
            } else {
                return false;
            }

            const fechaObj = new Date(year, month - 1, day);
            return (
                fechaObj.getFullYear() === year &&
                fechaObj.getMonth() === month - 1 &&
                fechaObj.getDate() === day
            );
        },

        async getEmpleados(registroPatronalId, fechaInicial, fechaFinal) {
            if(registroPatronalId == null) return;
            this.itemsEmpleados = [];
            const usuario = this.$session.get('usuario');
            let parametros = {
                paginate: false,
                usuario_id: usuario.id,
                rol_name: usuario.rol.name,
                activo: true,
                registro_patronal_id: registroPatronalId,
                fecha_inicio: fechaInicial,
                fecha_final: fechaFinal
            };
            await apiSeguridadSocial.getEmpleados(parametros).then((response) => {
                this.itemsEmpleados = response.data || response;
            })
            .catch(err => {
                console.log(err);
                Notify.ErrorToast("Ocurrió un error al cargar los empleados.");
            });
        },
        async getRegistrosPatronales(clienteId) {
            if(clienteId == null){
                return;
            }

            this.itemsRegistrosPatronales = [];
            let parametros = { activo:true, paginate:false, order:"asc", cliente_id: this.cliente_value }
            await apiRegistroPatronal.find(parametros).then((response) => {
                let format = response.data;
                if(response.data.length != 0){
                    format.forEach( item => {
                        item.nombreClave = item.nombre + ' - ' + item.clave
                        this.itemsRegistrosPatronales.push(item);
                    })
                }
            })
            .catch(err => {
                console.log(err);
                Notify.ErrorToast("Ocurrió un error al cargar los Registros Patronales.");
            });
        },
        selectAll(isSelected, items) {
            this.checkAll = isSelected;
            this.selected_general = items;

            if(!isSelected){
                this.unselected_general = [];
            }
        },
        async sincronizarEmpleados(){
            let params = {
                registro_patronal_id: this.registro_patronal_value
            }
            await apiSeguridadSocial.sincronizarMovimientos(params).then(response => {
                Notify.SuccessToast("Sincronización de empleados finalizado.");
                this.$refs.tablaAfiliacion.getData();
            })
        },
        async filtarMovimientos(){
            if(this.registro_patronal_value == null) {
                Notify.ErrorToast("Debe seleccionar un registro patronal.");
                return;
            }

            if(this.fecha_inicial == null || this.fecha_final == null) {
                Notify.ErrorToast("Debe seleccionar un rango de fechas.");
                return;
            }

            this.filters.fecha_movimiento_min = this.fecha_inicial
            this.filters.fecha_movimiento_max = this.fecha_final
            this.filters.estatus_movimiento = this.estatus
            this.filters.tipo_trabajador_id = this.mostrarBusquedaAvanzadaEstatus ? this.tipo_trabajador_id : null
            this.filters.tipo_salario_id = this.mostrarBusquedaAvanzadaEstatus ? this.tipo_salario_id : null
            this.filters.lote = this.mostrarBusquedaAvanzadaEstatus ? this.lote : null
            this.filters.nss = this.mostrarBusquedaAvanzadaEstatus ? this.nss : null
            this.filters.empleado_id = this.empleado_value || null
            this.filters.tipo = 'json'
            this.showTabla = true;

            await this.$refs.tablaAfiliacion.getData();
        },
        refresh(){

            this.showTabla = false;
            if(this.rol == 'root') {
                this.getClientes();
                this.cliente_value = null
            }
            else {
                this.cliente_value = this.datosLogin.cliente_id
            }
            this.registro_patronal_value = null
            this.fecha_inicial = null
            this.fecha_final = null
            this.estatus = null
            this.mostrarBusquedaAvanzadaEstatus = false
            this.tipo_trabajador_id = null
            this.tipo_salario_id = null
            this.lote = null
            this.nss = null
            this.selected_general = []
            this.unselected_general = []
            this.checkAll = false
            this.empleado_value = null
            this.itemsEmpleados = []
            this.filters = {
                activo    :true,
                paginate  :true,
                order     :"asc",
                registro_patronal_id: null,
                tipo_movimiento_clave: '08',
                estatus_movimiento: null,
                fecha_movimiento_min: null,
                fecha_movimiento_max: null,
                tipo_trabajador_id: null,
                tipo_salario_id: null,
                lote: null,
                nss: null,
                empleado_id: null,
                tipo: 'json'
            }
        },

        /**
         * @method dateFormat Esta método parsea una fecha
         * @description Convierte una fecha de formato AAAA-MM-DD => DD/MM/AAAA. Se usa para el modal y la tabla
         * @param {string} fecha formato AAAA-MM-DD
         * @param {string} tipo string con valor 'modal' o 'tabla'
         * @return {string} devuelve un string en formato DD/MM/AAAA
        */
        dateFormat(fecha, tipo) {
            if(fecha == null){
                return;
            }
            else{
                let fecha2 = fecha.split("-");
                if(tipo == 'modal'){
                    return fecha2[2] + "/" + fecha2[1]+ "/" + fecha2[0];
                }else{
                    return fecha2[2] + " / " + fecha2[1]+ " / " + fecha2[0];
                }
            }

        },

        async catalogosIMSS(){
            let params = {}
            await apiSeguridadSocial.catalogoIMSS(params).then(response => {
                this.itemsTiposTrabajadores = response.tipos_trabajadores;
                this.itemsTiposSalarios = response.tipos_salarios;
            })
        },
    },
    created() {
        this.datosLogin = this.$session.get("usuario");
        this.rol = this.datosLogin.rol.name;

        if(this.rol == 'root') {
            this.getClientes();
        }
        else {
            this.cliente_value = this.datosLogin.cliente_id
        }

    },
    mounted(){
        this.dataFake = datos
        this.catalogosIMSS()
        if(document.querySelector('#tablaAfiliacion')){
            if(document.querySelector('.emptyTable')) {
                document.querySelector('.emptyTable').style.width     = "6000px";
                document.querySelector('.emptyTable').style.minWidth   = "6000px";
                //document.querySelector('.tablaBody tr td').style.width     = "300px";
            }
        }
    },
    updated(){
        if(document.querySelector('#tablaAfiliacion')){
            if(document.querySelector('.emptyTable')) {
                document.querySelector('.emptyTable').style.width     = "6000px";
                document.querySelector('.emptyTable').style.minWidth   = "6000px";
            }
        }
        if(document.querySelector('#tablaAfiliacion')){
            if(document.querySelector('.emptyTable')) {
                document.querySelector('.tablaBody').style.maxHeight    = "none";
                document.querySelector('.tablaBody').style.width     = "6700px";
                document.querySelector('.tablaBody').style.minWidth   = "6000px";
                document.querySelector('.tablaBody').style.background   = "#fff";
                //document.querySelector('.tablaBody tr td').style.width     = "300px";
            }
        }
    }
}
</script>

<style scoped>
    .tablaBody{
        width: 2000px;
        max-height: none;
        min-width: 2500px;
    }
    .div-card {
        background-color: #fdfcfc;
        border-radius: 20px;
    }
    div.btnAccionesItem {
        width: 100%;
        cursor: pointer;
        outline: 0;
        padding-left: 30px;
        padding-right: 30px;
    }
    div.btnAccionesItem span {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        text-align: left;
        color: #828282;
    }
    div.btnAccionesItem:hover {
        background: #F6F6F8;
    }
    .deshabilitado{
        background:#fcf6f6;
        cursor:not-allowed;

        width: 100%;
        outline: 0;
        padding-left: 30px;
        padding-right: 30px;
    }
    div.deshabilitado:hover{
        background:#f2f2f2;
        cursor:not-allowed;

        width: 100%;
        outline: 0;
        padding-left: 30px;
        padding-right: 30px;
    }
    div.deshabilitado span {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        text-align: left;
        color: #828282;
    }
    .v-btn-excel::before {
        background-color: transparent;
    }
    .btn-afiliacion {
        background-color: #E4E4E5;
        height: 2.1875rem;
        border-radius: 8px;
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        cursor: pointer;
    }
    .btn-activo {
        color: #444975;
    }
    .btn-inactivo {
        color: #828282;
    }
    .text-no-elementos{
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 37px;
        color: #828282;
    }
    .error-list {
        max-height: 400px;
        overflow-y: auto;
        border-radius: 8px;
        padding: 8px;
    }
    .error-item {
        background-color: #FFFFFF;
        border-left: 3px solid #F44336;
        border-radius: 4px;
        padding: 8px;
    }
    .error-title {
        font-family: 'Montserrat';
        font-size: 14px;
        font-weight: 500;
        color: #424242;
        white-space: normal;
        word-break: break-word;
    }

</style>
